<template>
    <div>
        <validation-observer
                ref="observer"
        >
            <v-form ref="form" v-model="formValid" lazy-validation>
                <v-row>
                    <v-col cols="6">
                        <validation-provider
                                v-slot="{ errors }"
                                name="First Name"
                                rules="required"
                        >
                            <v-text-field
                                    v-model="value.firstName"
                                    label="First Name *"
                                    :error-messages="errors"
                            />
                        </validation-provider>
                    </v-col>
                    <v-col cols="6">
                        <validation-provider
                                v-slot="{ errors }"
                                name="Last Name"
                                rules="required"
                        >
                            <v-text-field
                                    v-model="value.lastName"
                                    label="Last Name *"
                                    :error-messages="errors"
                            />
                        </validation-provider>
                    </v-col>

                    <v-col cols="12">
                        <validation-provider
                                v-slot="{ errors }"
                                name="Email"
                                rules="required|email"
                        >
                            <v-text-field
                                    v-model="value.lastName"
                                    label="Email *"
                                    :error-messages="errors"
                            />
                        </validation-provider>
                    </v-col>
                </v-row>
                <v-row>
                    <v-container fluid>
                        <h3>Roles</h3>
                    <v-checkbox
                            v-model="value.roles"
                            v-for="role in roles"
                            :key="role.id"
                            :label="role.displayName"
                            :value="role.id"
                    />
                    </v-container>
                </v-row>
            </v-form>
        </validation-observer>
    </div>
</template>

<script>
    import {required} from 'vee-validate/dist/rules'
    import {extend, ValidationObserver, ValidationProvider, setInteractionMode} from 'vee-validate'
    import ROLES_LIST from "../../graphql/Roles/List.gql";

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            value: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },
        data() {
            return {

            }
        },
        apollo: {
            roles: {
                query: ROLES_LIST,
                update: data => data.roles
            },
        }
    }
</script>

<style scoped>

</style>